import { getCoreDataSecurityActionTemplateByIdSlice } from './get';

export const { requestGetCoreDataSecurityActionTemplateById, resetGetCoreDataSecurityActionTemplateById } =
    getCoreDataSecurityActionTemplateByIdSlice.asyncActionCreators;
